<template>
  <div>
    <!-- 新增信息 -->
    <i-modal :value="showModal" width="40%" class-name="vertical-center-modal" @on-cancel="cancel">
      <div slot="header" class="title">
        <h2>增加属性</h2>
      </div>
      <div style="text-align:center" class="modifyRole">
        <i-row class="a-row">
          <i-col span="5" offset="1">
            <span>名称：</span>
          </i-col>
          <i-col span="15">
            <i-input class="fontsize" v-model="updateName"></i-input>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="5" offset="1">
            <span class="title">简介：</span>
          </i-col>
          <i-col span="15">
            <i-input type="textarea" :rows="4" class="fontsize" v-model="updateDesc"></i-input>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="5" offset="1">
            <span class="title">类型：</span>
          </i-col>
          <i-col span="15">
            <i-input class="fontsize" v-model="updateType"></i-input>
          </i-col>
        </i-row>
        <i-row class="a-row">
          <i-col span="5" offset="1">
            <span class="title">是否支持排序：</span>
          </i-col>
          <i-col span="15">
            <i-switch v-model="sortable" />
            {{ sortable ? "是" : "否" }}
          </i-col>
        </i-row>
      </div>
      <div slot="footer" style="text-align:center">
        <i-button type="primary" size="large" style="width:200px" @click.native="submitAddArr">确认</i-button>
      </div>
    </i-modal>
  </div>
</template>

<script>
import { baseConfigMixin } from "../mixin"
export default {
  data() {
    return {
      updateName: "", //新增的属性名字
      updateDesc: "", //新增的属性简介
      updateType: "", //新增的属性类型
      sortable: false, //是否支持排序
    }
  },
  mixins: [baseConfigMixin],
  props: {
    showModal: {
      type: Boolean,
    },
    attrName: {
      type: String,
    },
    attrDesc: {
      type: String,
    },
    attrId: {
      type: String,
    },
  },
  methods: {
    cancel() {
      this.updateName = ""
      this.updateDesc = ""
      this.$emit("cancelModal")
    },
    async submitAddArr() {
      if (this.updateName === "") {
        this.$Message.error("属性名不能为空")
        return
      }
      if (this.updateType === "") {
        this.$Message.error("属性类型不能为空")
        return
      }
      let xData = {
        name: this.updateName,
        desc: this.updateDesc,
        a_type: this.updateType,
        sortable: this.sortable ? 1 : 0,
      }
      if (this.updateDesc) {
        xData["desc"] = this.updateDesc
      }
      const res = await this.axios({
        method: "get",
        url: this.cmsUrl + "api/content/attribute/add",
        params: xData,
      })
      if (!res) {
        return
      }
      if (res.data.code === 0) {
        this.$Message.success("新增属性成功")
        this.$emit("updateList")
        this.cancel()
      } else {
        this.showLoading = false
        this.$Message.error("操作失败，错误原因：" + res.data.error_message)
      }
    },
  },
  watch: {
    attrName(newV) {
      this.updateName = newV
    },
    attrDesc(newV) {
      this.updateDesc = newV
    },
  },
}
</script>

<style lang="scss">
.title {
  text-align: center;
}
.a-row {
  margin: 15px 0 30px 0;
}
</style>
